<template>
  <app-layout>
    <template v-slot:adminnav> </template>
    <div>
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-3">
        <PageTitle class="font-semibold text-lg text-gray-800 leading-tight">
          Invoice
        </PageTitle>
        <p class="text-xs">
          We’re updating the cards and ranking all the time, so check back
          regularly.
        </p>
      </div>
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div>
          <div>
            <div class="row"></div>
            <div class="mt-2">
              <div
                class="bg-white overflow-hidden shadow-xl px-2 py-2 sm:rounded-lg"
              >
                <BsIndex
                  :slug="slug"
                  :routeDef="moduleRoute"
                  :dataRoute="dataRoute"
                  :headersDef="headers"
                >
                </BsIndex>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>
<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsIndex from "@/Base/BsIndex.vue";

export default {
  props: {
    moduleRoute: String,
    headers: Array,
    moduleName: String,
    slug: String,
    dataRoute: String,
  },
  components: {
    BsIndex,
    AppLayout,
  },
};
</script>


<style>
.main-content {
  background-color: #f3f4f6;
  /* width: calc(100% - 250px); */
  /* height: 100vh; */
  margin-left: 212px;
  padding: 10px;
}
@media only screen and (max-width: 420px) {
  .main-content {
    width: 100%;
    margin-left: 0;
    z-index: -1;
    position: relative;
  }
}
@media only screen and (max-width: 768px) {
  .main-content {
    width: 100%;
    margin-left: 0;
    z-index: -1;
    position: relative;
  }
}
</style>